{
  "cycle.entite.documentation_pages": "Pages de la documentation du projet",
  "cycle.entite.politiques_approbation_environnement": "Politiques d’approbation des environnements",
  "journalAudit.action.docs.regenerated": "Documentation du projet régénérée",
  "journalAudit.action.environment.approval_policy_changed": "Politique d’approbation d’un environnement modifiée"
}
